import { createModel } from "hox";
import { TablePaginationConfig } from "antd/es/table/interface";
import { IPgProps, ISearchPage } from "@/types/ScmTypes";
import React, { useState, useEffect } from "react";
import { PaginationProps } from "antd/es/pagination";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, } from "@/utils/constants";
import { IAppointmentDetail, IAppointmentSearchField, IAppointmentStatistics } from "./appointmentTypes";
import { transPgToPagination, formatNum } from "@/utils/utils";
import { appointmentService } from "./appointmentService"
import { message } from "antd";
import { convertRes2Blob } from "@/utils/exportFile";

export const useAppointmentModel = createModel(function () {
    const initSearchParam: IAppointmentSearchField = {};
    const initDataSource: IAppointmentDetail[] = [];
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const initDesc: IAppointmentStatistics = {
        materialScienceAmount: 0,
        totalAmount: 0,
        workHour: 0,
        workingHoursAmount: 0
    }
    //查询条件
    const [searchParam, setSearchParam] = useState<IAppointmentSearchField>(initSearchParam);
    //列表数据源
    const [dataSource, setDataSource] = useState<IAppointmentDetail[]>(initDataSource);
    //表格选中行Key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
    //表格选中的值
    const [selectedRow, setSelectedRow] = useState<IAppointmentDetail>({});
    const [descTotal, setDescTotal] = useState<IAppointmentStatistics>(initDesc);
    //选中的数据统计展示的数据
    const [rowsDescTotal, setRowsDescTotal] = useState<any>(initDesc);
    const [descRows, setDescRows] = useState<IAppointmentDetail[]>([]);



    //列表数据源分页参数
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);

    useEffect(() => {
        let filters = dataSource.filter(el => selectedRowKeys.length > 0 ? el.id === selectedRowKeys[0] : false);
        const selectedData = filters && filters.length > 0 ? filters[0] : undefined;
        setSelectedRow(selectedData as IAppointmentDetail)
    }, [selectedRowKeys])
    useEffect(() => {
        let newRowsDescTotal = initDesc
        descRows.forEach((item) => {
            let { workHour, workingHoursAmount, materialScienceAmount, receivableTotalAmount } = item
            newRowsDescTotal.workHour += +formatNum(workHour)
            newRowsDescTotal.workingHoursAmount += +formatNum(workingHoursAmount)
            newRowsDescTotal.materialScienceAmount += +formatNum(materialScienceAmount)
            newRowsDescTotal.totalAmount += +formatNum(receivableTotalAmount)
        })
        setRowsDescTotal(newRowsDescTotal)
    }, [descRows])
    const updatePgCfg = (updateParam: TablePaginationConfig) => {
        setPgCfg({ ...pgCfg, ...updateParam })
    }
    const updateSearchParam = (updateParam: IAppointmentSearchField) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }
    const resetSearchParam = () => {
        setSearchParam(initSearchParam);
        loadData(initPgCfg, {});
        setSelectedRowKeys([])
    }
    const loadData = async (page?: ISearchPage, searchValue: IAppointmentSearchField = searchParam) => {
        const searchParams = {
            ...searchValue,
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.pageNum || page?.current) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
        }
        let { retData } = await appointmentService.page(searchParams);
        const { records, statistics, ...pg } = retData;
        setPgCfg(transPgToPagination({ ...pg, pageNum: pg.current }));
        setDataSource(records);
        setDescTotal(statistics);
    }
    const invalidateData = async (obj: object) => {
        let { retData } = await appointmentService.invalidate(obj)
        if (retData) {
            message.success("作废成功");
            loadData();
        }
    }
    //预约转工单
    const Transfer = async () => {
        let params = {
            "id": selectedRow.id,
            "appointmentCode": selectedRow.appointmentCode
        }
        let { retData } = await appointmentService.transfer(params);
        return retData;
    }
    //列表导出
    const listExport = async () => {
        let result = await appointmentService.export({ ...searchParam, id: selectedRowKeys.join(), });
        convertRes2Blob(result)
    }
    const detailsExport = async () => {
        let result = await appointmentService.detailsExport({
            ...searchParam,
            id: selectedRowKeys.join(),
            "pageSize": "0",
            "pageNum": "0",
        });
        convertRes2Blob(result)
    }
    return {
        /***field***/
        searchParam,
        dataSource,
        selectedRowKeys,
        pgCfg,
        selectedRow,
        /***method***/
        setDataSource,
        setSelectedRowKeys,
        resetSearchParam,
        updateSearchParam,
        loadData,
        updatePgCfg,
        invalidateData,
        setSelectedRow,
        Transfer,
        listExport,
        detailsExport,
        descTotal, setDescTotal,
        rowsDescTotal, setRowsDescTotal,
        descRows, setDescRows
    }
})
